import { Controller } from 'react-hook-form';
import { Checkbox } from '@ui/src';
import { PaymentTypesInputTypes } from './types';

import cn from './item-form.module.css';

const PaymentTypesInput = ({
  control,
  isEditable,
  itemId,
  paymentsTypes,
  paymentTypes,
}: PaymentTypesInputTypes) => (
  <div>
    {paymentsTypes?.map((paymentType) => (
      <div className={cn.itemFormCheckboxWrapper} key={paymentType}>
        <Controller
          control={control}
          name="paymentsTypes"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              name={`paymentType-${paymentType}`}
              title={
                paymentTypes?.find((type) => type.paymentType === paymentType)
                  ?.name || ''
              }
              onChange={() => {
                let nextValues = ([] as string[]).concat(value);

                if (nextValues.includes(paymentType)) {
                  nextValues = nextValues.filter(
                    (item) => item !== paymentType,
                  );
                } else {
                  nextValues.push(paymentType);
                }

                onChange(nextValues);
              }}
              type="checkbox"
              checked={value?.includes(paymentType)}
              disabled={Boolean(itemId && !isEditable)}
              tabIndex={itemId && !isEditable ? -1 : 0}
            />
          )}
        />
      </div>
    ))}
  </div>
);

export default PaymentTypesInput;
